import type React from "react";

type Props = {
  children: React.ReactNode;
  classNames: string;
};

export const NavMovil = ({ children, classNames }: Props): JSX.Element => {
  return (
    <nav className="navigation--mobile classNav">
      <div className={`w-100 d-flex justify-content-between ${classNames}`}>
        {children}
      </div>
    </nav>
  );
};
